<template>
  <div v-loading="talentLoading" style="min-height: 200px">
    <div v-if="achData && achData.length && !talentLoading">
      <div class="person-item" v-for="(item,i) in achData" :key="i" @click="toDetail(item.id)">
        <div style="margin-left: 8px">
          <div class="person-name">{{ item.title }}</div>
          <div class="item-left" v-if="item.authors && item.authors.length">
            作者：
            <span class="item-right" style="margin-right: 9px" v-for="(auther,index) in item.authors.length > 3?item.authors.splice(0,3):item.authors" :key="index">
          <el-avatar fit="cover" :size="14" :src="auther.avatarUrl" @error="errorHandler">
            <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png" />
          </el-avatar>
              <span style="margin-left: 3px">{{ auther.scholarName }}</span>
          </span>
          </div>
          <div class="item-left" v-else>作者：<span class="item-right" style="margin-right: 9px">-</span></div>
          <div class="item-left">
            项目类别：<span class="item-right">{{ item.typeFirst || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <el-empty/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'projectList',
  components: {},
  props: ["achData",'talentLoading'],
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    toDetail(id) {
      let obj = {
        name: 'projectDetail',
        query: { id },
      };
      let routeData = this.$router.resolve(obj);
      window.open(routeData.href, '_blank');
    },
    errorHandler() {
      return true;
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">

.person-item {
  margin: 5px 19px;
  display: flex;
  cursor: pointer;
  padding: 15px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #DEE2E9;

  .person-name {
    font-weight: 500;
    line-height: 26px;
    font-size: 18px;
    color: #181F33;
  }

  .item-left {
    display: flex;
    align-items: center;
    line-height: 24px;
    margin-top: 11px;
    font-size: 14px;
    color: #8191B2;
  }

  .item-right {
    display: flex;
    line-height: 24px;
    align-items: center;
    font-size: 14px;
    color: #50607F;
  }

  .item-num {
    font-size: 14px;
    color: #464BFE;
    margin-left: 4px;
  }
}

</style>
